import { Grid } from '@mui/material';
import React from 'react';
import { isMobile } from 'react-device-detect';

import Projects from '../../../../data/Projects';
import type { ArtProject } from '../../../../utils/Types';
import ArtProjectCard from './ArtProjectCard';

const ArtProjectsView = () => {
    return (
        <div id="art-projects-view" className="art-projects-view">
            <Grid
                container
                spacing={isMobile === true ? 2 : 6}
                sx={{
                    alignItems: 'flex-start',
                    justifyContent: 'flex-start',
                }}
            >
                {Projects.get('art').map((p, i) => (
                    <ArtProjectCard project={p as ArtProject} key={i} />
                ))}
            </Grid>
        </div>
    );
};

export default ArtProjectsView;
